import { Input, Label } from '@heathmont/moon-core-tw';
import CopyToClipboard from 'react-copy-to-clipboard';
import useTranslation from '~/client/hooks/i18n/useTranslation';

type Props = {
  walletAddress?: string;
  destinationTag?: string;
  currency: CashierCurrency;
  handleCopy: (currency?: CashierCurrency) => void;
};

const AddressInputs: FC<Props> = ({
  walletAddress = '',
  destinationTag,
  currency,
  handleCopy,
}) => {
  const xrpLabel = useTranslation('cashier.deposit_destination_tag');
  return (
    <>
      <CopyToClipboard
        text={walletAddress?.toString()}
        onCopy={() => handleCopy()}
      >
        <div className="flex flex-col">
          <Label className="text-trunks">
            {useTranslation('cashier.your_address')}
          </Label>
          <Input
            className="min-w-[19.5rem] cursor-pointer bg-goku"
            value={walletAddress}
          />
        </div>
      </CopyToClipboard>
      {destinationTag && (
        <CopyToClipboard
          text={destinationTag.toString()}
          onCopy={() => handleCopy(currency)}
        >
          <div className="flex flex-col">
            <Label className="text-trunks">{xrpLabel}</Label>
            <Input
              className="min-w-[19.5rem] cursor-pointer bg-goku"
              value={destinationTag}
            />
          </div>
        </CopyToClipboard>
      )}
    </>
  );
};

export default AddressInputs;
